import React, { Component, createRef } from 'react';
import { bool, number, object, func } from 'prop-types';
import _ from 'lodash';
import {
  newFetchCouponData,
  newSendCouponToMedia
} from '../../../services/Api/Coupon/CouponService';
import ButtonSection from './ButtonSection.js';
import TextMaskCustom from '../../static/TextMaskCustom';
import { validateMail } from '../../../services/Api/User/UserService';
import Notification from '../../common/Notification.jsx';
import { withTranslation } from 'react-i18next';
import {
  GTM_PHYSICAL_CARD_CONFIRMATION_TEXT_CLICK,
  GTM_PHYSICAL_CARD_CONFIRMATION_TEXT_SEND_SUCCESS,
  GTM_PHYSICAL_CARD_CONFIRMATION_EMAIL_CLICK,
  GTM_PHYSICAL_CARD_CONFIRMATION_EMAIL_SEND_SUCCESS,
  GTM_PHYSICAL_CARD_CONFIRMATION_PRINT_CLICK,
  GTM_PHYSICAL_CARD_CONFIRMATION_PRINT_CARD_GENERATED
} from '../../../constants/defaults';
import { AuthContext } from '../../../Contexts';
const invalidChars = ['-', '+', 'e', '.'];
const printJs = typeof window !== 'undefined' ? require('print-js') : undefined;

class RxCardSendCoupon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMedia: '',
      inputText: '',
      requiredInput: false,
      validationError: false,
      showButton: false,
      activeButton: true,
      disabledTextBtn: false,
      disabledMailBtn: false,
      apiLoading: false,
      displaySent: false,
      pdfLoading: false
    };
    this.inputRef = createRef();
    this.linkRef = createRef();
  }

  static contextType = AuthContext;

  toggleShow(showMedia = '') {
    if (this.state.showMedia !== showMedia) {
      if (this.props.isFromDiscountPage || this.props.ispharmacySpecificPage) {
        const { selectedPrice } = this.props;
        _.triggerGTMVirtualPageViewEvent({
          event:
            showMedia === 'Email'
              ? 'couponEmailButtonClick'
              : 'couponTextButtonClick',
          buttonLocation: 'prescription-discount-card',
          PharmacyName: selectedPrice.PharmacyName
            ? selectedPrice.PharmacyName
            : 'SingleCare'
        });
      }
      if (this.props.isFromPhysicalModal) {
        this.props.triggerGTMEvents(
          showMedia === 'Email'
            ? GTM_PHYSICAL_CARD_CONFIRMATION_EMAIL_CLICK
            : GTM_PHYSICAL_CARD_CONFIRMATION_TEXT_CLICK
        );
      }
      this.setState({
        showButton:
          showMedia === 'Email' &&
          this?.context?.userData?.isLoggedIn &&
          this.validateEmail(this?.context?.userData?.email)
      });

      this.setState({
        showMedia,
        inputText:
          showMedia === 'Email' && this?.context?.userData?.isLoggedIn
            ? this?.context?.userData?.email
            : '',
        requiredInput: false,
        activeButton: false
      });
    }
  }

  handleInputChange(e = { preventDefault() {}, target: { value: '' } }) {
    e.preventDefault();
    const { value } = e.target;
    const { showMedia } = this.state;
    if (showMedia === 'Text' && invalidChars.indexOf(value) !== -1) {
      return;
    }

    if (
      (showMedia === 'Text' &&
        value.length <= 14 &&
        !invalidChars.includes(value)) ||
      showMedia === 'Email'
    ) {
      this.setState({ showButton: this.validateEmail(value) });

      this.setState({
        inputText: value,
        requiredInput: false,
        validationError: false
      });
    }
  }

  validateEmail(email) {
    // Handle regex escape for eslint
    const re =
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    return re.test(email);
  }

  handleInputBlur(event = { preventDefault() {}, target: { value: '' } }) {
    event.preventDefault();
    const { value } = event.target;
    if (this.linkRef.current.contains(event?.relatedTarget)) {
      return;
    }
    if (this.state.inputText.length === 0) {
      this.setState({ requiredInput: true });
      return;
    }
    const validation =
      this.state.showMedia === 'Email'
        ? !this.validateEmail(value)
        : !(this.state.inputText.length === 14);

    if (validation) {
      this.setState({ requiredInput: true, validationError: true });
    }
  }

  async handleSubmit(e = { preventDefault() {} }) {
    e.preventDefault();
    const { showMedia } = this.state;
    //this.setState({ apiLoading: true });
    if (showMedia === 'Email' || showMedia === 'Text') {
      let isValidMail = true;
      let textValue = this.state.inputText;
      if (textValue.length === 0) {
        return;
      }
      if (this.state.showMedia === 'Text') {
        if (this.state.inputText.length === 14) {
          this.setState({ apiLoading: true });
          textValue = this.state.inputText.replace(/\D/g, '');
          this.setState({ disabledTextBtn: true });
          setTimeout(() => this.setState({ disabledTextBtn: false }), 5000);
        } else {
          this.setState({ requiredInput: true, validationError: true });
          return;
        }
      } else {
        //this.setState({ disabledMailBtn: true });
        if (
          this.state.inputText.length <= 0 ||
          !this.state.showButton ||
          this.state.disabledMailBtn
        ) {
          this.setState({ requiredInput: true, validationError: true });
          return;
        }
        this.setState({ apiLoading: true });
        const responseData = await validateMail(this.state.inputText);
        if (responseData && _.isEqual(responseData.result, 'undeliverable')) {
          this.setState({
            requiredInput: true,
            validationError: true,
            apiLoading: false
          });
          isValidMail = false;
          this.setState({ disabledMailBtn: false });
        }
        setTimeout(() => this.setState({ disabledMailBtn: false }), 5000);
      }
      if (isValidMail) {
        const { selectedPrice, drugData, quantity, doNotMarket, isRxCard } =
          this.props;
        const drugName = doNotMarket ? 'Your Prescription' : drugData.Name;
        try {
          let couponData = await newSendCouponToMedia(
            selectedPrice.PartnerUser,
            selectedPrice.PartnerPassword,
            drugName,
            selectedPrice.PharmacyName,
            drugData.Form,
            drugData.Dosage,
            quantity,
            _.parsePriceValue(selectedPrice),
            this.state.showMedia,
            textValue.trim(),
            isRxCard,
            null,
            null,
            false,
            false,
            false,
            null,
            null,
            this?.context?.userData?.isLoggedIn
          );
          if (couponData) {
            if (couponData.data && couponData.data.Result) {
              let result = couponData.data.Result;
              let finalEventObj = {
                event:
                  showMedia === 'Email'
                    ? 'couponEmailSendSuccess'
                    : 'couponTextSendSuccess',
                formId: showMedia === 'Email' ? 'email' : 'text',
                authNumber: result.MemberNumberFull,
                grpNumber: result.GroupNumber,
                bin: result.BIN,
                pcn: result.PCN,
                PharmacyName: selectedPrice.PharmacyName
                  ? selectedPrice.PharmacyName
                  : 'SingleCare'
              };
              if (this.props.isFromDiscountPage) {
                _.triggerGTMVirtualPageViewEvent(finalEventObj);
              }
              let triggerEventObj = {
                authNumber: result.MemberNumberFull,
                grpNumber: result.GroupNumber,
                bin: result.BIN,
                pcn: result.PCN
              };
              if (this.props.isFromPhysicalModal) {
                this.props.triggerGTMEvents(
                  showMedia === 'Email'
                    ? GTM_PHYSICAL_CARD_CONFIRMATION_EMAIL_SEND_SUCCESS
                    : GTM_PHYSICAL_CARD_CONFIRMATION_TEXT_SEND_SUCCESS,
                  triggerEventObj
                );
              }
            }
            this.props.setIsmobileDisplaySent(true, showMedia);
            setTimeout(() => {
              this.props.setIsmobileDisplaySent(false, showMedia);
            }, 5000);
            this.setState({ apiLoading: false, displaySent: true }, () => {
              setTimeout(() => {
                this.setState({ displaySent: false });
              }, 4000);
            });
          } else {
            this.setState({ apiLoading: false, apiError: true });
          }
          this.props.showNotification(this.state.showMedia, true);
        } catch (err) {
          console.log('Error occured on submit:', err.message);
        }
      }
    }
  }

  async handlePrintPFD(e = { preventDefault() {} }) {
    e.preventDefault();

    this.setState({ pdfLoading: true });
    if (this.props.isFromPhysicalModal) {
      this.props.triggerGTMEvents(GTM_PHYSICAL_CARD_CONFIRMATION_PRINT_CLICK);
    }
    const { PartnerUser, PartnerPassword, PharmacyName } =
      this.props.selectedPrice;
    let utmParams = _.getUTMParams();
    const couponData = await newFetchCouponData(
      PartnerUser,
      PartnerPassword,
      '1',
      utmParams
    );
    if (!_.isEmpty(couponData.PDFUrl)) {
      if (this.props.isFromPhysicalModal) {
        this.props.triggerGTMEvents(
          GTM_PHYSICAL_CARD_CONFIRMATION_PRINT_CARD_GENERATED,
          {
            authNumber: couponData.MemberNumberFull,
            grpNumber: couponData.GroupNumber,
            bin: couponData.BIN,
            pcn: couponData.PCN
          }
        );
      } else {
        _.triggerGTMVirtualPageViewEvent({
          event: 'printCouponGenerated',
          buttonLocation: this.props.buttonLocation,
          authNumber: couponData.MemberNumberFull,
          grpNumber: couponData.GroupNumber,
          bin: couponData.BIN,
          pcn: couponData.PCN,
          PharmacyName: PharmacyName ? PharmacyName : 'SingleCare'
        });
      }
      printJs({
        printable: couponData.PDFUrl,
        type: 'image'
      });
    }
    this.setState({
      showMedia: '',
      inputText: '',
      requiredInput: false,
      activeButton: true,
      pdfLoading: false
    });
  }

  render() {
    const {
      classes,
      t,
      i18n,
      isFromDiscountPage,
      openModal,
      triggerGTMEvents,
      closeMobileButtonModal,
      isLandingPages
    } = this.props;
    let lang = i18n.language;
    return (
      <div className="send-section">
        <ButtonSection
          classes={classes}
          toggleShow={this.toggleShow.bind(this)}
          printAsPDF={this.handlePrintPFD.bind(this)}
          activeButton={this.state.activeButton}
          showMedia={this.state.showMedia}
          pdfLoading={this.state.pdfLoading}
          openModal={openModal}
          triggerGTMEvents={triggerGTMEvents}
          closeMobileButtonModal={closeMobileButtonModal}
        />
        {_.isEmpty(this.state.showMedia) &&
          isFromDiscountPage &&
          isLandingPages && (
            <p className="cardNote textCenter desktop-only">
              {t(
                'Use the search bar above to look up exact prices for your prescriptions.'
              )}
            </p>
          )}
        {!_.isEmpty(this.state.showMedia) && (
          <form
            className="input-section"
            ref={form => (this.form = form)}
            onSubmit={this.handleSubmit.bind(this)}
          >
            {_.isEqual(this.state.showMedia, 'Text') ? (
              <div>
                <div className="input-container">
                  <div className={`input-container send-btn-label`}>
                    <label className="input-label">
                      <span className="input-label">{t('Phone Number')}</span>
                      <div className="inputWrapper">
                        <TextMaskCustom
                          id="standard-number"
                          inputRef={ref => (this.inputRef = ref)}
                          value={this.state.inputText}
                          onChange={this.handleInputChange.bind(this)}
                          className={`themeFocus dialogComponent mobileDialog ${
                            this.state.requiredInput
                              ? 'errorInput'
                              : 'input-component'
                          }`}
                          onBlur={this.handleInputBlur.bind(this)}
                          autoComplete="off"
                          placeholder="(212)123-4567"
                          autoFocus
                          aria-invalid={
                            this.state.validationError ||
                            this.state.requiredInput
                              ? 'true'
                              : 'false'
                          }
                          aria-describedby="standard-numbererror"
                          inputMode="numeric"
                        />
                        {this.state.requiredInput && (
                          <img
                            className="errorImage"
                            src="/content/images/icons/error.svg"
                            alt=""
                          />
                        )}
                      </div>
                      <span
                        id="standard-numbererror"
                        className={`label-error ${
                          !this.state.requiredInput && 'hidden'
                        }`}
                        role="alert"
                      >
                        {`Error: ${
                          this.state.validationError
                            ? t('Please enter a valid phone number')
                            : t(
                                'Rx-Card Phone number must be ten digits and include area code.'
                              )
                        }`}
                      </span>
                    </label>
                    <div className="button-section" aria-live="polite">
                      {!this.state.apiLoading ? (
                        this.state.displaySent ? (
                          <div className="messageSent">
                            <img
                              src="/content/images/icons/sentIcon.png"
                              alt="sent icon"
                            />
                            <span role="status">{t('Rx-card-Sent')}</span>
                          </div>
                        ) : (
                          <button
                            className={`submit-button text-send themeFocus dialogComponent mobileDialog ${
                              this.state.inputText.length === 14 && 'enabled'
                            }`}
                            onClick={this.handleSubmit.bind(this)}
                            aria-live="polite"
                          >
                            {t('Send')}
                          </button>
                        )
                      ) : (
                        <img
                          src="/content/images/loader/loading.gif"
                          alt="loader"
                          className="sendLoader"
                        />
                        // <div className="messageSent">Sent</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="terms-container" ref={this.linkRef}>
                  <div className={`${classes.demo} labelText`}>
                    <p className="send-terms">
                      {t('T-and-C text1')}
                      {t('See')}&nbsp;
                      <a
                        href={_.withLocale(lang, '/terms-and-conditions')}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="dialogComponent mobileDialog"
                      >
                        {t('Terms & Conditions Text')}
                      </a>
                      .&nbsp;{t('Text STOP to quit.')}
                      <p className="send-terms-message">
                        &nbsp;
                        {t('Message & data rates may apply.')}
                      </p>
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className="input-container">
                  <div className={`send-btn-label input-container`}>
                    <label className="input-label">
                      <span className="input-label">{t('Email Address')}</span>
                      <div className="inputWrapper">
                        <input
                          id="standard-number"
                          value={this.state.inputText}
                          onChange={this.handleInputChange.bind(this)}
                          className={`themeFocus dialogComponent mobileDialog ${
                            this.state.requiredInput
                              ? 'errorInput'
                              : 'input-component'
                          }`}
                          onBlur={this.handleInputBlur.bind(this)}
                          placeholder="johnsmith@email.com"
                          autoComplete="email"
                          autoFocus
                          aria-invalid={
                            this.state.validationError ||
                            this.state.requiredInput
                              ? 'true'
                              : 'false'
                          }
                          aria-describedby="standard-numbererror"
                        />
                        {this.state.requiredInput && (
                          <img
                            className="errorImage"
                            src="/content/images/icons/error.svg"
                            alt=""
                          />
                        )}
                      </div>
                      <span
                        id="standard-numbererror"
                        className={`label-error ${
                          !this.state.requiredInput && 'hidden'
                        }`}
                        role="alert"
                      >
                        {`Error: ${
                          this.state.validationError
                            ? t('Please enter a valid email address.')
                            : t('RxCard-This value is required.')
                        }`}
                      </span>
                    </label>
                    <div className="button-section" aria-live="polite">
                      {!this.state.apiLoading ? (
                        this.state.displaySent ? (
                          <div className="messageSent">
                            <img
                              src="/content/images/icons/sentIcon.png"
                              alt="sent icon"
                            />
                            <span role="status">{t('Rx-card-Sent')}</span>
                          </div>
                        ) : (
                          <button
                            className={`submit-button email-send themeFocus dialogComponent mobileDialog ${
                              this.state.showButton && 'enabled'
                            }`}
                            onClick={this.handleSubmit.bind(this)}
                            aria-live="polite"
                          >
                            {t('Send')}
                          </button>
                        )
                      ) : (
                        <img
                          src="/content/images/loader/loading.gif"
                          alt="loader"
                          className="sendLoader"
                        />
                        // <div className="messageSent">Sent</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="terms-container" ref={this.linkRef}>
                  <div className="labelText">
                    <p className="send-terms">
                      {t('T-and-C email')}&nbsp;
                      <a
                        href={_.withLocale(lang, '/terms-and-conditions')}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="dialogComponent mobileDialog"
                      >
                        {t('Terms & Conditions')}
                      </a>
                      {i18n.language === 'es' ? ' de SingleCare' : ''}.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </form>
        )}
        {this.state.apiError && (
          <Notification
            show={this.state.apiError}
            errorMessage={''}
            hideError={() => {
              this.setState({ apiError: false });
            }}
          />
        )}
      </div>
    );
  }
}

RxCardSendCoupon.propTypes = {
  classes: object,
  selectedPrice: object,
  drugData: object,
  quantity: number,
  showNotification: func,
  doNotMarket: bool,
  apiSuccess: bool,
  isRxCard: bool,
  setIsmobileDisplaySent: func,
  isFromDiscountPage: bool,
  ispharmacySpecificPage: bool,
  triggerGTMEvents: func,
  openModal: func
};

RxCardSendCoupon.defaultProps = {
  classes: {},
  selectedPrice: { PBAClientName: '', PartnerPassword: '' },
  drugData: { Name: '', Form: '', Dosage: '' },
  quantity: 0,
  showNotification: () => {},
  doNotMarket: false,
  apiSuccess: false,
  isRxCard: false,
  setIsmobileDisplaySent: () => {},
  isFromDiscountPage: false,
  ispharmacySpecificPage: false,
  triggerGTMEvents: () => {},
  openModal: () => {}
};

export default withTranslation()(RxCardSendCoupon);
